import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/internal/operators/map';
import { ConfigurationService } from '@config/configuration.service';
import { AppQuestionData } from '@models/app-question-data';
import { GridDetailParameterConfigModel } from 'app/shared/models/grid-detail-parameter-config.model';


@Injectable({
  providedIn: 'root'
})
export class SummaryService {
  
  backUrl: string = this.configSvc.configuration.UrlBackEnd;

  constructor(private http: HttpClient, private configSvc: ConfigurationService) { }

  SaveService(serviceData: Array<AppQuestionData>, files: any) {
    return this.http.put<any>(this.backUrl + '/SaveService', { "AppQuestionData": serviceData, "Files": files }).pipe(
      map(x => { return x.Data })
    );
  }

  GetTollMesagge(idGrid: number){
    return this.http.get<Array<GridDetailParameterConfigModel>>(this.backUrl + '/GetTollMesagge', { params: { idGrid: idGrid.toString()}})
    .pipe(map(x => x));
  }

  TrackUsersActions(actionTypeId: number, identityEntityId: number, nameIdentityEntity: string) {
    return this.http.post<any>(this.backUrl + '/TrackWebAppCurrentUserActions', { ActionTypeId: actionTypeId, IdIdentityEntity: identityEntityId, NameIdentityEntity: nameIdentityEntity }).pipe(
      map(x => x.Data)
    );
  }
}
